// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-width: 0;
  color: var(--ca-text-primary, #172033);
}

.reports-page {
  width: 100%;
  min-width: 0;
  padding: 0.25rem clamp(0.75rem, 2vw, 1.5rem) 2rem;
  color: var(--ca-text-primary, #172033);
}

.breadcrumb {
  margin-top: 1.5rem;
  margin-left: 1.5rem;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 1.25rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.875rem;
}

.breadcrumb-link {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font: inherit;
  text-decoration: none;
  cursor: pointer;
}
.breadcrumb-link:hover {
  color: var(--ca-primary-dark, #0d2863);
  text-decoration: underline;
}
.breadcrumb-link:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 3px;
  border-radius: var(--ca-radius-sm, 6px);
}

.breadcrumb-link i {
  font-size: 1.25rem;
}

.breadcrumb-separator {
  color: var(--ca-text-muted, #8c96a8);
}

.breadcrumb-current {
  color: var(--ca-text-secondary, #4b5870);
  font-weight: 500;
}

.breadcrumb-current i {
  font-size: 1.25rem;
}

.reports-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  margin: 0 0 1.35rem;
}

.reports-heading-copy {
  min-width: 0;
}
.reports-heading-copy h1 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.55rem, 2.3vw, 1.95rem);
  font-weight: 750;
  letter-spacing: -0.035em;
  line-height: 1.25;
}
.reports-heading-copy > p:last-child {
  max-width: 740px;
  margin: 0.5rem 0 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
  line-height: 1.6;
}

.reports-eyebrow {
  display: flex;
  align-items: center;
  margin: 0 0 0.45rem;
  color: var(--ca-primary-light, #2850ad);
  font-size: 0.69rem;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.reports-header-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.5rem;
  height: 3.5rem;
  flex: 0 0 3.5rem;
  border: 1px solid rgba(40, 80, 173, 0.15);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1.45rem;
}

.report-toolbar-card {
  display: flex;
  align-items: center;
  gap: 1.1rem;
  min-width: 0;
  margin-bottom: 1.25rem;
  padding: 1rem 1.15rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.filter-block {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  min-width: 15rem;
}

.toolbar-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.7rem;
  height: 2.7rem;
  flex: 0 0 2.7rem;
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1.05rem;
}

.filter-copy {
  min-width: 0;
  flex: 1 1 auto;
}
.filter-copy .form-label {
  display: block;
  margin: 0 0 0.25rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.74rem;
  font-weight: 650;
}

.report-filter {
  width: 100%;
  min-width: 10.5rem;
  min-height: 2.5rem;
  border-color: var(--ca-input-border, #dfe4ec);
  border-radius: var(--ca-radius-sm, 6px);
  background-color: var(--ca-input-bg, #fff);
  color: var(--ca-text-primary, #172033);
  font-size: 0.85rem;
}
.report-filter:focus {
  border-color: var(--ca-input-focus, #2850ad);
  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.15);
}
.report-filter:disabled {
  background-color: var(--ca-bg-secondary, #eef2f8);
  cursor: wait;
}

.report-toolbar-divider {
  align-self: stretch;
  width: 1px;
  background: var(--ca-border-light, #e9edf3);
}

.report-action-copy {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 10rem;
}

.toolbar-label {
  color: var(--ca-text-primary, #172033);
  font-size: 0.85rem;
  font-weight: 700;
}

.toolbar-hint {
  margin-top: 0.2rem;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.75rem;
}

.report-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.55rem;
}

.report-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 2.5rem;
  padding: 0.6rem 0.9rem;
  border-radius: var(--ca-radius-sm, 6px);
  font-size: 0.82rem;
  font-weight: 650;
  white-space: nowrap;
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}
.report-action-btn i {
  font-size: 0.95rem;
}
.report-action-btn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.reports-page .btn-primary {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
  color: #fff;
}
.reports-page .btn-primary:hover:not(:disabled) {
  border-color: var(--ca-primary-dark, #0d2863);
  background: var(--ca-primary-dark, #0d2863);
}
.reports-page .btn-primary:focus-visible {
  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.2);
}

.reports-page .btn-secondary {
  border: 1px solid var(--ca-border, #dfe4ec);
  background: var(--ca-surface, #fff);
  color: var(--ca-primary, #0e2e80);
}
.reports-page .btn-secondary:hover:not(:disabled) {
  border-color: var(--ca-primary-light, #2850ad);
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary-dark, #0d2863);
}

.reports-loading-banner,
.reports-alert {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  margin: 0 0 1rem;
  padding: 0.8rem 1rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-surface, #fff);
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.82rem;
}

.reports-loading-banner .spinner-border,
.panel-loading .spinner-border {
  color: var(--ca-primary, #0e2e80);
}

.reports-alert-error {
  border-color: #f3b9c0;
  background: var(--ca-danger-bg, #fdecef);
  color: #842029;
}
.reports-alert-error .btn {
  margin-left: auto;
}

.pdf-preview-panel {
  overflow: hidden;
  margin: 0 0 1.25rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-md, 0 4px 12px rgba(7, 17, 46, 0.08));
}

.pdf-preview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.2rem;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  background: #fbfcff;
}

.pdf-preview-heading {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
}
.pdf-preview-heading h2 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 0.95rem;
  font-weight: 750;
}
.pdf-preview-heading p {
  margin: 0.2rem 0 0;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.75rem;
  text-transform: capitalize;
}

.pdf-preview-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  flex: 0 0 2.5rem;
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-danger, #dc3545);
  font-size: 1.1rem;
}

.close-preview-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  flex: 0 0 auto;
  font-size: 0.8rem;
}

.pdf-viewer {
  display: block;
  width: 100%;
  height: min(78vh, 900px);
  min-height: 440px;
  border: 0;
  background: #eef2f8;
}

.reports-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: stretch;
  gap: 1.15rem;
}

.report-panel {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 350px;
  overflow: hidden;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.report-panel:hover {
  border-color: var(--ca-border, #dfe4ec);
  box-shadow: var(--ca-shadow-md, 0 4px 12px rgba(7, 17, 46, 0.08));
}

.report-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  min-height: 5.35rem;
  padding: 1rem 1.1rem;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  background: linear-gradient(180deg, #fff 0%, #fbfcff 100%);
}

.panel-heading-copy {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
}
.panel-heading-copy h2 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 0.96rem;
  font-weight: 750;
  line-height: 1.35;
}
.panel-heading-copy p {
  margin: 0.25rem 0 0;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.75rem;
  line-height: 1.45;
}

.panel-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.55rem;
  height: 2.55rem;
  flex: 0 0 2.55rem;
  border-radius: var(--ca-radius-md, 8px);
  font-size: 1.05rem;
}

.icon-blue {
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
}

.icon-cyan {
  background: #eaf6fc;
  color: #1d7fbf;
}

.icon-violet {
  background: #f1edff;
  color: #6b55b4;
}

.icon-amber {
  background: var(--ca-warning-bg, #fff7e6);
  color: #a96b00;
}

.panel-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  flex: 0 0 auto;
  padding: 0.32rem 0.55rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 999px;
  background: var(--ca-bg, #f5f7fb);
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.68rem;
  font-weight: 650;
  white-space: nowrap;
}

.report-panel-body {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
  padding: 1rem;
}

.report-table {
  display: block;
  min-width: 0;
  overflow-x: auto;
}

.report-panel-body ::ng-deep app-report-table table {
  min-width: 100%;
  margin-bottom: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 0.82rem;
}

.report-panel-body ::ng-deep app-report-table thead th {
  padding: 0.75rem 0.8rem;
  border-bottom: 1px solid var(--ca-border, #dfe4ec);
  background: #f4f6fa;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.7rem;
  font-weight: 750;
  letter-spacing: 0.025em;
  text-transform: uppercase;
  white-space: nowrap;
}

.report-panel-body ::ng-deep app-report-table tbody td {
  padding: 0.75rem 0.8rem;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  color: var(--ca-text-secondary, #4b5870);
  vertical-align: middle;
}

.report-panel-body ::ng-deep app-report-table tbody tr:hover td {
  background: #f7f9fd;
}

.panel-loading {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  min-height: 220px;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.82rem;
}

.empty-report-state {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 220px;
  padding: 1.5rem 1rem;
  text-align: center;
}
.empty-report-state h3 {
  margin: 0.65rem 0 0.25rem;
  color: var(--ca-text-primary, #172033);
  font-size: 0.9rem;
  font-weight: 700;
}
.empty-report-state p {
  max-width: 300px;
  margin: 0;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.78rem;
  line-height: 1.5;
}

.empty-report-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.7rem;
  height: 2.7rem;
  border-radius: 50%;
  background: var(--ca-bg-secondary, #eef2f8);
  color: var(--ca-text-muted, #8c96a8);
  font-size: 1.15rem;
}

.error-icon {
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-danger, #dc3545);
}

.compact-empty {
  min-height: 300px;
}

.chart-canvas-wrap {
  position: relative;
  width: 100%;
  height: 300px;
  min-height: 260px;
}

.chart-canvas-wrap canvas {
  display: block;
  width: 100% !important;
  height: 100% !important;
  max-width: 100%;
}

.chart-canvas-wrap-pie {
  height: 310px;
}

@media (max-width: 1100px) {
  .report-toolbar-card {
    flex-wrap: wrap;
  }
  .report-action-copy {
    flex: 1 1 12rem;
  }
  .report-actions {
    margin-left: auto;
  }
}
@media (max-width: 850px) {
  .reports-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .report-panel {
    min-height: 300px;
  }
  .report-toolbar-divider {
    display: none;
  }
  .report-action-copy {
    flex-basis: 100%;
  }
  .report-actions {
    width: 100%;
    margin-left: 0;
    justify-content: flex-start;
  }
}
@media (max-width: 575.98px) {
  .reports-page {
    padding-right: 0.25rem;
    padding-left: 0.25rem;
  }
  .reports-header {
    align-items: flex-start;
    gap: 0.7rem;
  }
  .reports-header-mark {
    width: 2.8rem;
    height: 2.8rem;
    flex-basis: 2.8rem;
    font-size: 1.15rem;
  }
  .report-toolbar-card {
    align-items: stretch;
    padding: 0.9rem;
  }
  .filter-block {
    width: 100%;
    min-width: 0;
  }
  .report-actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .report-action-btn {
    padding: 0.6rem 0.5rem;
    font-size: 0.75rem;
  }
  .report-panel-header {
    align-items: flex-start;
    padding: 0.9rem;
  }
  .panel-heading-copy {
    align-items: flex-start;
    gap: 0.55rem;
  }
  .panel-icon {
    width: 2.2rem;
    height: 2.2rem;
    flex-basis: 2.2rem;
    font-size: 0.95rem;
  }
  .panel-count {
    font-size: 0.63rem;
  }
  .report-panel-body {
    padding: 0.7rem;
  }
  .pdf-preview-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .pdf-viewer {
    min-height: 360px;
    height: 65vh;
  }
}
@media (prefers-reduced-motion: reduce) {
  .report-panel,
  .report-action-btn {
    transition: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/data-protection/reports/reports.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;EACA,sCAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,iDAAA;EACA,sCAAA;AACF;;AAGA;EACE,kBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,iCAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;AAAF;AAEE;EACE,sCAAA;EACA,0BAAA;AAAJ;AAGE;EACE,0CAAA;EACA,mBAAA;EACA,uCAAA;AADJ;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,oCAAA;AAFF;;AAKA;EAEE,wCAAA;EACA,gBAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AAHF;;AAMA;EACE,YAAA;AAHF;AAKE;EACE,SAAA;EACA,sCAAA;EACA,yCAAA;EACA,gBAAA;EACA,wBAAA;EACA,iBAAA;AAHJ;AAME;EACE,gBAAA;EACA,kBAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;AAJJ;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AALF;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,yCAAA;EACA,wCAAA;EACA,6CAAA;EACA,iCAAA;EACA,kBAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,qBAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,gEAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AALF;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,uCAAA;EACA,6CAAA;EACA,iCAAA;EACA,kBAAA;AALF;;AAQA;EACE,YAAA;EACA,cAAA;AALF;AAOE;EACE,cAAA;EACA,mBAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;AALJ;;AASA;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,6CAAA;EACA,uCAAA;EACA,0CAAA;EACA,sCAAA;EACA,kBAAA;AANF;AAQE;EACE,4CAAA;EACA,gDAAA;AANJ;AASE;EACE,iDAAA;EACA,YAAA;AAPJ;;AAWA;EACE,mBAAA;EACA,UAAA;EACA,2CAAA;AARF;;AAWA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;AARF;;AAWA;EACE,sCAAA;EACA,kBAAA;EACA,gBAAA;AARF;;AAWA;EACE,kBAAA;EACA,oCAAA;EACA,kBAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;AARF;;AAWA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uFAAA;AARF;AAUE;EAAI,kBAAA;AAPN;AASE;EAAa,mBAAA;EAAqB,aAAA;AALpC;;AAQA;EACE,wCAAA;EACA,sCAAA;EACA,WAAA;AALF;AAOE;EACE,6CAAA;EACA,2CAAA;AALJ;AAQE;EAAkB,+CAAA;AALpB;;AAQA;EACE,2CAAA;EACA,mCAAA;EACA,iCAAA;AALF;AAOE;EACE,8CAAA;EACA,6CAAA;EACA,sCAAA;AALJ;;AASA;;EAEE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,iDAAA;EACA,uCAAA;EACA,mCAAA;EACA,wCAAA;EACA,kBAAA;AANF;;AASA;;EACiC,iCAAA;AALjC;;AAOA;EACE,qBAAA;EACA,wCAAA;EACA,cAAA;AAJF;AAME;EAAO,iBAAA;AAHT;;AAMA;EACE,gBAAA;EACA,mBAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,iEAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,oBAAA;EACA,wDAAA;EACA,mBAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AAHF;AAKE;EACE,SAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AAHJ;AAME;EACE,kBAAA;EACA,uCAAA;EACA,kBAAA;EACA,0BAAA;AAJJ;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,uCAAA;EACA,wCAAA;EACA,gCAAA;EACA,iBAAA;AALF;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AALF;;AAQA;EACE,cAAA;EACA,WAAA;EACA,wBAAA;EACA,iBAAA;EACA,SAAA;EACA,mBAAA;AALF;;AAQA;EACE,aAAA;EACA,gDAAA;EACA,oBAAA;EACA,YAAA;AALF;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,gEAAA;EACA,wDAAA;AALF;AAOE;EACE,uCAAA;EACA,iEAAA;AALJ;;AASA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,wDAAA;EACA,0DAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AANF;AAQE;EACE,SAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AANJ;AASE;EACE,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,iBAAA;AAPJ;;AAWA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,uCAAA;EACA,kBAAA;AARF;;AAWA;EAAa,6CAAA;EAA+C,iCAAA;AAN5D;;AAOA;EAAa,mBAAA;EAAqB,cAAA;AAFlC;;AAGA;EAAe,mBAAA;EAAqB,cAAA;AAEpC;;AADA;EAAc,yCAAA;EAA2C,cAAA;AAMzD;;AAJA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;EACA,wBAAA;EACA,iDAAA;EACA,oBAAA;EACA,iCAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAOF;;AAJA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;AAOF;;AAJA;EACE,cAAA;EACA,YAAA;EACA,gBAAA;AAOF;;AAJA;EACE,eAAA;EACA,gBAAA;EACA,sCAAA;EACA,kBAAA;AAOF;;AAJA;EACE,uBAAA;EACA,kDAAA;EACA,mBAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;AAOF;;AAJA;EACE,uBAAA;EACA,wDAAA;EACA,wCAAA;EACA,sBAAA;AAOF;;AAJA;EAAkE,mBAAA;AAQlE;;AANA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,wCAAA;EACA,kBAAA;AASF;;AANA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AASF;AAPE;EACE,yBAAA;EACA,sCAAA;EACA,iBAAA;EACA,gBAAA;AASJ;AANE;EACE,gBAAA;EACA,SAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;AAQJ;;AAJA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,2CAAA;EACA,oCAAA;EACA,kBAAA;AAOF;;AAJA;EAAc,wCAAA;EAA0C,gCAAA;AASxD;;AARA;EAAiB,iBAAA;AAYjB;;AAVA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;AAaF;;AAVA;EACE,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;AAaF;;AAVA;EAAyB,aAAA;AAczB;;AAZA;EACE;IAAuB,eAAA;EAgBvB;EAfA;IAAsB,eAAA;EAkBtB;EAjBA;IAAkB,iBAAA;EAoBlB;AACF;AAlBA;EACE;IAAgB,qCAAA;EAqBhB;EApBA;IAAgB,iBAAA;EAuBhB;EAtBA;IAA0B,aAAA;EAyB1B;EAxBA;IAAsB,gBAAA;EA2BtB;EA1BA;IAAkB,WAAA;IAAa,cAAA;IAAgB,2BAAA;EA+B/C;AACF;AA7BA;EACE;IAAgB,sBAAA;IAAwB,qBAAA;EAiCxC;EAhCA;IAAkB,uBAAA;IAAyB,WAAA;EAoC3C;EAnCA;IAAuB,aAAA;IAAe,cAAA;IAAgB,kBAAA;IAAoB,kBAAA;EAyC1E;EAxCA;IAAuB,oBAAA;IAAsB,eAAA;EA4C7C;EA3CA;IAAgB,WAAA;IAAa,YAAA;EA+C7B;EA9CA;IAAkB,aAAA;IAAe,gDAAA;EAkDjC;EAjDA;IAAqB,sBAAA;IAAwB,kBAAA;EAqD7C;EApDA;IAAuB,uBAAA;IAAyB,eAAA;EAwDhD;EAvDA;IAAsB,uBAAA;IAAyB,YAAA;EA2D/C;EA1DA;IAAc,aAAA;IAAe,cAAA;IAAgB,kBAAA;IAAoB,kBAAA;EAgEjE;EA/DA;IAAe,kBAAA;EAkEf;EAjEA;IAAqB,eAAA;EAoErB;EAnEA;IAAsB,uBAAA;IAAyB,sBAAA;EAuE/C;EAtEA;IAAc,iBAAA;IAAmB,YAAA;EA0EjC;AACF;AAxEA;EACE;;IACqB,gBAAA;EA2ErB;AACF","sourcesContent":[":host {\r\n  display: block;\r\n  min-width: 0;\r\n  color: var(--ca-text-primary, #172033);\r\n}\r\n\r\n.reports-page {\r\n  width: 100%;\r\n  min-width: 0;\r\n  padding: 0.25rem clamp(0.75rem, 2vw, 1.5rem) 2rem;\r\n  color: var(--ca-text-primary, #172033);\r\n}\r\n\r\n\r\n.breadcrumb {\r\n  margin-top: 1.5rem;\r\n  margin-left: 1.5rem;\r\n}\r\n\r\n.breadcrumb-nav {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  margin: 0 0 1.25rem;\r\n  color: var(--ca-text-tertiary, #6f7b91);\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.breadcrumb-link {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.25rem;\r\n  padding: 0;\r\n  border: 0;\r\n  background: transparent;\r\n  color: var(--ca-primary, #0e2e80);\r\n  font: inherit;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n\r\n  &:hover {\r\n    color: var(--ca-primary-dark, #0d2863);\r\n    text-decoration: underline;\r\n  }\r\n\r\n  &:focus-visible {\r\n    outline: 3px solid rgba(40, 80, 173, 0.25);\r\n    outline-offset: 3px;\r\n    border-radius: var(--ca-radius-sm, 6px);\r\n  }\r\n}\r\n\r\n.breadcrumb-link i {\r\n  font-size: 1.25rem;\r\n}\r\n\r\n.breadcrumb-separator {\r\n  color: var(--ca-text-muted, #8c96a8);\r\n}\r\n\r\n.breadcrumb-current {\r\n  \r\n  color: var(--ca-text-secondary, #4b5870);\r\n  font-weight: 500;\r\n}\r\n\r\n.breadcrumb-current i {\r\n  font-size: 1.25rem;\r\n}\r\n\r\n.reports-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1.5rem;\r\n  margin: 0 0 1.35rem;\r\n}\r\n\r\n.reports-heading-copy {\r\n  min-width: 0;\r\n\r\n  h1 {\r\n    margin: 0;\r\n    color: var(--ca-text-primary, #172033);\r\n    font-size: clamp(1.55rem, 2.3vw, 1.95rem);\r\n    font-weight: 750;\r\n    letter-spacing: -0.035em;\r\n    line-height: 1.25;\r\n  }\r\n\r\n  > p:last-child {\r\n    max-width: 740px;\r\n    margin: 0.5rem 0 0;\r\n    color: var(--ca-text-secondary, #4b5870);\r\n    font-size: 0.9rem;\r\n    line-height: 1.6;\r\n  }\r\n}\r\n\r\n.reports-eyebrow {\r\n  display: flex;\r\n  align-items: center;\r\n  margin: 0 0 0.45rem;\r\n  color: var(--ca-primary-light, #2850ad);\r\n  font-size: 0.69rem;\r\n  font-weight: 800;\r\n  letter-spacing: 0.12em;\r\n}\r\n\r\n.reports-header-mark {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 3.5rem;\r\n  height: 3.5rem;\r\n  flex: 0 0 3.5rem;\r\n  border: 1px solid rgba(40, 80, 173, 0.15);\r\n  border-radius: var(--ca-radius-lg, 12px);\r\n  background: var(--ca-surface-active, #eef3ff);\r\n  color: var(--ca-primary, #0e2e80);\r\n  font-size: 1.45rem;\r\n}\r\n\r\n.report-toolbar-card {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1.1rem;\r\n  min-width: 0;\r\n  margin-bottom: 1.25rem;\r\n  padding: 1rem 1.15rem;\r\n  border: 1px solid var(--ca-border-light, #e9edf3);\r\n  border-radius: var(--ca-radius-lg, 12px);\r\n  background: var(--ca-surface, #fff);\r\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\r\n}\r\n\r\n.filter-block {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.8rem;\r\n  min-width: 15rem;\r\n}\r\n\r\n.toolbar-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 2.7rem;\r\n  height: 2.7rem;\r\n  flex: 0 0 2.7rem;\r\n  border-radius: var(--ca-radius-md, 8px);\r\n  background: var(--ca-surface-active, #eef3ff);\r\n  color: var(--ca-primary, #0e2e80);\r\n  font-size: 1.05rem;\r\n}\r\n\r\n.filter-copy {\r\n  min-width: 0;\r\n  flex: 1 1 auto;\r\n\r\n  .form-label {\r\n    display: block;\r\n    margin: 0 0 0.25rem;\r\n    color: var(--ca-text-secondary, #4b5870);\r\n    font-size: 0.74rem;\r\n    font-weight: 650;\r\n  }\r\n}\r\n\r\n.report-filter {\r\n  width: 100%;\r\n  min-width: 10.5rem;\r\n  min-height: 2.5rem;\r\n  border-color: var(--ca-input-border, #dfe4ec);\r\n  border-radius: var(--ca-radius-sm, 6px);\r\n  background-color: var(--ca-input-bg, #fff);\r\n  color: var(--ca-text-primary, #172033);\r\n  font-size: 0.85rem;\r\n\r\n  &:focus {\r\n    border-color: var(--ca-input-focus, #2850ad);\r\n    box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.15);\r\n  }\r\n\r\n  &:disabled {\r\n    background-color: var(--ca-bg-secondary, #eef2f8);\r\n    cursor: wait;\r\n  }\r\n}\r\n\r\n.report-toolbar-divider {\r\n  align-self: stretch;\r\n  width: 1px;\r\n  background: var(--ca-border-light, #e9edf3);\r\n}\r\n\r\n.report-action-copy {\r\n  display: flex;\r\n  flex: 1 1 auto;\r\n  flex-direction: column;\r\n  min-width: 10rem;\r\n}\r\n\r\n.toolbar-label {\r\n  color: var(--ca-text-primary, #172033);\r\n  font-size: 0.85rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.toolbar-hint {\r\n  margin-top: 0.2rem;\r\n  color: var(--ca-text-muted, #8c96a8);\r\n  font-size: 0.75rem;\r\n}\r\n\r\n.report-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  flex-wrap: wrap;\r\n  gap: 0.55rem;\r\n}\r\n\r\n.report-action-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n  min-height: 2.5rem;\r\n  padding: 0.6rem 0.9rem;\r\n  border-radius: var(--ca-radius-sm, 6px);\r\n  font-size: 0.82rem;\r\n  font-weight: 650;\r\n  white-space: nowrap;\r\n  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;\r\n\r\n  i { font-size: 0.95rem; }\r\n\r\n  &:disabled { cursor: not-allowed; opacity: 0.55; }\r\n}\r\n\r\n.reports-page .btn-primary {\r\n  border-color: var(--ca-primary, #0e2e80);\r\n  background: var(--ca-primary, #0e2e80);\r\n  color: #fff;\r\n\r\n  &:hover:not(:disabled) {\r\n    border-color: var(--ca-primary-dark, #0d2863);\r\n    background: var(--ca-primary-dark, #0d2863);\r\n  }\r\n\r\n  &:focus-visible { box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.2); }\r\n}\r\n\r\n.reports-page .btn-secondary {\r\n  border: 1px solid var(--ca-border, #dfe4ec);\r\n  background: var(--ca-surface, #fff);\r\n  color: var(--ca-primary, #0e2e80);\r\n\r\n  &:hover:not(:disabled) {\r\n    border-color: var(--ca-primary-light, #2850ad);\r\n    background: var(--ca-surface-active, #eef3ff);\r\n    color: var(--ca-primary-dark, #0d2863);\r\n  }\r\n}\r\n\r\n.reports-loading-banner,\r\n.reports-alert {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.7rem;\r\n  margin: 0 0 1rem;\r\n  padding: 0.8rem 1rem;\r\n  border: 1px solid var(--ca-border-light, #e9edf3);\r\n  border-radius: var(--ca-radius-md, 8px);\r\n  background: var(--ca-surface, #fff);\r\n  color: var(--ca-text-secondary, #4b5870);\r\n  font-size: 0.82rem;\r\n}\r\n\r\n.reports-loading-banner .spinner-border,\r\n.panel-loading .spinner-border { color: var(--ca-primary, #0e2e80); }\r\n\r\n.reports-alert-error {\r\n  border-color: #f3b9c0;\r\n  background: var(--ca-danger-bg, #fdecef);\r\n  color: #842029;\r\n\r\n  .btn { margin-left: auto; }\r\n}\r\n\r\n.pdf-preview-panel {\r\n  overflow: hidden;\r\n  margin: 0 0 1.25rem;\r\n  border: 1px solid var(--ca-border-light, #e9edf3);\r\n  border-radius: var(--ca-radius-lg, 12px);\r\n  background: var(--ca-surface, #fff);\r\n  box-shadow: var(--ca-shadow-md, 0 4px 12px rgba(7, 17, 46, 0.08));\r\n}\r\n\r\n.pdf-preview-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  padding: 1rem 1.2rem;\r\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\r\n  background: #fbfcff;\r\n}\r\n\r\n.pdf-preview-heading {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  min-width: 0;\r\n\r\n  h2 {\r\n    margin: 0;\r\n    color: var(--ca-text-primary, #172033);\r\n    font-size: 0.95rem;\r\n    font-weight: 750;\r\n  }\r\n\r\n  p {\r\n    margin: 0.2rem 0 0;\r\n    color: var(--ca-text-tertiary, #6f7b91);\r\n    font-size: 0.75rem;\r\n    text-transform: capitalize;\r\n  }\r\n}\r\n\r\n.pdf-preview-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 2.5rem;\r\n  height: 2.5rem;\r\n  flex: 0 0 2.5rem;\r\n  border-radius: var(--ca-radius-md, 8px);\r\n  background: var(--ca-danger-bg, #fdecef);\r\n  color: var(--ca-danger, #dc3545);\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.close-preview-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.45rem;\r\n  flex: 0 0 auto;\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.pdf-viewer {\r\n  display: block;\r\n  width: 100%;\r\n  height: min(78vh, 900px);\r\n  min-height: 440px;\r\n  border: 0;\r\n  background: #eef2f8;\r\n}\r\n\r\n.reports-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  align-items: stretch;\r\n  gap: 1.15rem;\r\n}\r\n\r\n.report-panel {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  min-height: 350px;\r\n  overflow: hidden;\r\n  border: 1px solid var(--ca-border-light, #e9edf3);\r\n  border-radius: var(--ca-radius-lg, 12px);\r\n  background: var(--ca-surface, #fff);\r\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\r\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\r\n\r\n  &:hover {\r\n    border-color: var(--ca-border, #dfe4ec);\r\n    box-shadow: var(--ca-shadow-md, 0 4px 12px rgba(7, 17, 46, 0.08));\r\n  }\r\n}\r\n\r\n.report-panel-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 0.75rem;\r\n  min-height: 5.35rem;\r\n  padding: 1rem 1.1rem;\r\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\r\n  background: linear-gradient(180deg, #fff 0%, #fbfcff 100%);\r\n}\r\n\r\n.panel-heading-copy {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  min-width: 0;\r\n\r\n  h2 {\r\n    margin: 0;\r\n    color: var(--ca-text-primary, #172033);\r\n    font-size: 0.96rem;\r\n    font-weight: 750;\r\n    line-height: 1.35;\r\n  }\r\n\r\n  p {\r\n    margin: 0.25rem 0 0;\r\n    color: var(--ca-text-tertiary, #6f7b91);\r\n    font-size: 0.75rem;\r\n    line-height: 1.45;\r\n  }\r\n}\r\n\r\n.panel-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 2.55rem;\r\n  height: 2.55rem;\r\n  flex: 0 0 2.55rem;\r\n  border-radius: var(--ca-radius-md, 8px);\r\n  font-size: 1.05rem;\r\n}\r\n\r\n.icon-blue { background: var(--ca-surface-active, #eef3ff); color: var(--ca-primary, #0e2e80); }\r\n.icon-cyan { background: #eaf6fc; color: #1d7fbf; }\r\n.icon-violet { background: #f1edff; color: #6b55b4; }\r\n.icon-amber { background: var(--ca-warning-bg, #fff7e6); color: #a96b00; }\r\n\r\n.panel-count {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.4rem;\r\n  flex: 0 0 auto;\r\n  padding: 0.32rem 0.55rem;\r\n  border: 1px solid var(--ca-border-light, #e9edf3);\r\n  border-radius: 999px;\r\n  background: var(--ca-bg, #f5f7fb);\r\n  color: var(--ca-text-secondary, #4b5870);\r\n  font-size: 0.68rem;\r\n  font-weight: 650;\r\n  white-space: nowrap;\r\n}\r\n\r\n.report-panel-body {\r\n  display: flex;\r\n  flex: 1 1 auto;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  padding: 1rem;\r\n}\r\n\r\n.report-table {\r\n  display: block;\r\n  min-width: 0;\r\n  overflow-x: auto;\r\n}\r\n\r\n.report-panel-body ::ng-deep app-report-table table {\r\n  min-width: 100%;\r\n  margin-bottom: 0;\r\n  color: var(--ca-text-primary, #172033);\r\n  font-size: 0.82rem;\r\n}\r\n\r\n.report-panel-body ::ng-deep app-report-table thead th {\r\n  padding: 0.75rem 0.8rem;\r\n  border-bottom: 1px solid var(--ca-border, #dfe4ec);\r\n  background: #f4f6fa;\r\n  color: var(--ca-text-secondary, #4b5870);\r\n  font-size: 0.7rem;\r\n  font-weight: 750;\r\n  letter-spacing: 0.025em;\r\n  text-transform: uppercase;\r\n  white-space: nowrap;\r\n}\r\n\r\n.report-panel-body ::ng-deep app-report-table tbody td {\r\n  padding: 0.75rem 0.8rem;\r\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\r\n  color: var(--ca-text-secondary, #4b5870);\r\n  vertical-align: middle;\r\n}\r\n\r\n.report-panel-body ::ng-deep app-report-table tbody tr:hover td { background: #f7f9fd; }\r\n\r\n.panel-loading {\r\n  display: flex;\r\n  flex: 1 1 auto;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.65rem;\r\n  min-height: 220px;\r\n  color: var(--ca-text-secondary, #4b5870);\r\n  font-size: 0.82rem;\r\n}\r\n\r\n.empty-report-state {\r\n  display: flex;\r\n  flex: 1 1 auto;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 220px;\r\n  padding: 1.5rem 1rem;\r\n  text-align: center;\r\n\r\n  h3 {\r\n    margin: 0.65rem 0 0.25rem;\r\n    color: var(--ca-text-primary, #172033);\r\n    font-size: 0.9rem;\r\n    font-weight: 700;\r\n  }\r\n\r\n  p {\r\n    max-width: 300px;\r\n    margin: 0;\r\n    color: var(--ca-text-tertiary, #6f7b91);\r\n    font-size: 0.78rem;\r\n    line-height: 1.5;\r\n  }\r\n}\r\n\r\n.empty-report-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 2.7rem;\r\n  height: 2.7rem;\r\n  border-radius: 50%;\r\n  background: var(--ca-bg-secondary, #eef2f8);\r\n  color: var(--ca-text-muted, #8c96a8);\r\n  font-size: 1.15rem;\r\n}\r\n\r\n.error-icon { background: var(--ca-danger-bg, #fdecef); color: var(--ca-danger, #dc3545); }\r\n.compact-empty { min-height: 300px; }\r\n\r\n.chart-canvas-wrap {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 300px;\r\n  min-height: 260px;\r\n}\r\n\r\n.chart-canvas-wrap canvas {\r\n  display: block;\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n  max-width: 100%;\r\n}\r\n\r\n.chart-canvas-wrap-pie { height: 310px; }\r\n\r\n@media (max-width: 1100px) {\r\n  .report-toolbar-card { flex-wrap: wrap; }\r\n  .report-action-copy { flex: 1 1 12rem; }\r\n  .report-actions { margin-left: auto; }\r\n}\r\n\r\n@media (max-width: 850px) {\r\n  .reports-grid { grid-template-columns: minmax(0, 1fr); }\r\n  .report-panel { min-height: 300px; }\r\n  .report-toolbar-divider { display: none; }\r\n  .report-action-copy { flex-basis: 100%; }\r\n  .report-actions { width: 100%; margin-left: 0; justify-content: flex-start; }\r\n}\r\n\r\n@media (max-width: 575.98px) {\r\n  .reports-page { padding-right: 0.25rem; padding-left: 0.25rem; }\r\n  .reports-header { align-items: flex-start; gap: 0.7rem; }\r\n  .reports-header-mark { width: 2.8rem; height: 2.8rem; flex-basis: 2.8rem; font-size: 1.15rem; }\r\n  .report-toolbar-card { align-items: stretch; padding: 0.9rem; }\r\n  .filter-block { width: 100%; min-width: 0; }\r\n  .report-actions { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); }\r\n  .report-action-btn { padding: 0.6rem 0.5rem; font-size: 0.75rem; }\r\n  .report-panel-header { align-items: flex-start; padding: 0.9rem; }\r\n  .panel-heading-copy { align-items: flex-start; gap: 0.55rem; }\r\n  .panel-icon { width: 2.2rem; height: 2.2rem; flex-basis: 2.2rem; font-size: 0.95rem; }\r\n  .panel-count { font-size: 0.63rem; }\r\n  .report-panel-body { padding: 0.7rem; }\r\n  .pdf-preview-header { align-items: flex-start; flex-direction: column; }\r\n  .pdf-viewer { min-height: 360px; height: 65vh; }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .report-panel,\r\n  .report-action-btn { transition: none; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
